import Label from "../shared/label/label";
import Wrapper from "../shared/wrapper/wrapper";
import { DatepickerFieldProps } from "./types/datepickerFieldProps";
import { stylizationWrapper } from "../shared/stylization";
import { labelProps } from "../shared/label/types/labelProps";
import { ReactComponent as emergencyHome } from '../../icons/emergency_home.svg';
import { ReactComponent as cancel } from '../../icons/cancel.svg';
import ErrorTip from "../shared/errorTip/errorTip";
import { TipProps } from "../shared/errorTip/types/errorTipProps";
import { useEffect, useState } from "react";
import { inputStateType, validation } from "../../helpers/validation/validation";
import { DatepickerCustomizedProps, DatepickerProps } from "../shared/datepicker/types/datepickerProps";
import Datepicker from "../shared/datepicker/datepicker";

const DatepickerField = (props: DatepickerFieldProps) => {

    var stylization = props.style !== undefined ? props.style : stylizationWrapper;

    const [errorCautionDisplay, setErrorCautionDisplay] = useState('none');
    const [pristine, setPristine] = useState(props.pristine);
    const [inputState, setInputState] = useState('');
    const [errorText, setErrorText] = useState(props.tipText);

    const showError = () => {
        setErrorCautionDisplay('inline-block');
        setInputState(inputStateType.inputError);
    }

    const clearError = () => {
        setErrorCautionDisplay('none');
        setInputState('');
    }

    const showValid = () => {
        if (!props.keepPristine) setInputState(inputStateType.inputValid);
    }

    const clearValid = () => {
        setInputState('');
    }

    useEffect(() => {    
        if (props.validationError === true) {
            var errorText = validation(props.configValidation, props.selected);
            if (errorText) {
                setErrorText(errorText);
                showError();
            } else {
                clearError();
                if (!pristine) showValid();
            }
        } else {
            clearError();
            if (!pristine) showValid();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.validationError, pristine, props.tipText, props.reload])

    const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.setValue) props.setValue(event);
        var errorText = validation(props.configValidation, event);
        if (errorText) {
            clearValid();
            setErrorText(errorText);
            showError();
        }
        else {
            setPristine(false);
            if (event) {
                clearError();
                showValid();
                setErrorText('');
            }
        }
    }

    var datepickerProps: DatepickerProps = {
        onChange: onChangeInput,
        dateFormat: props.dateFormat,
        minDate: props.minDate,
        maxDate: props.maxDate,
        selected: props.selected,
        shouldCloseOnSelect: props.shouldCloseOnSelect,
        fixedHeight: props.fixedHeight,
        placeholderText: props.inputPlaceholder,
        disabled: props.searching || props.disabled,
        showYearPicker: props.showYearPicker,
        showMonthYearPicker: props.showMonthYearPicker,
        hideTodayBtn: props.hideTodayBtn,
        className: `${props.datepickerSharedProps?.className && props.datepickerSharedProps?.className !== undefined ? props.datepickerSharedProps?.className : ''} ${inputState}`
    }

    var datepickerCustomizedProps: DatepickerCustomizedProps = {
        props: datepickerProps,
        additionalIcon: props.additionalIcon,
        classNameIcon: "iconOrange",
        displayIcon: 'inline-block',
        searching: props.searching,
        className: props.className,
        addCommentBtn: props.addCommentBtn,
        inputRef: props.inputRef,
        onClickFilterComments: props.setCommentsFilter,
        isMarkedForCommentFilter: props.isMarkedForCommentFilter
    }

    var labelProps: labelProps = {
        style: {
            marginBottom: '10px',
            display: props.hideLabel ? 'none' : 'inline-block'
        }
    }

    var tipProps: TipProps = {
        style: {
            display: errorCautionDisplay
        }
    }

    return (
        <Wrapper style={stylization} children={
            <>
                <Label {...labelProps} className='body-txt-medium' labelname={props.labelName} />
                <Datepicker {...datepickerCustomizedProps} />
                <ErrorTip props={tipProps} tipText={errorText} tipType={inputState === inputStateType.inputError ? 'errorTip' : undefined} additionalIcon={inputState === inputStateType.inputWarning ?  emergencyHome : cancel}></ErrorTip>
            </>
        } />)
}

export default DatepickerField;